import { IntensityDenominatorKinds } from '../utils/intensityDenominators';
import { AggregateMethod, BiSupportedMeasure } from './types';

export const BASIC_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'tco2eQuantity',
    supportedDenominators: [
      'tco2eQuantity',
      // per 1000 sq ft instead of per sq ft
      'buildingAreaScaledQuantity',
      // these legacy intensities will be actually shown
      // only if the org has data for them
      ...IntensityDenominatorKinds,
    ],
  },
  {
    measure: 'tco2eLocationQuantity',
    supportedDenominators: [
      'tco2eLocationQuantity',
      // per 1000 sq ft instead of per sq ft
      'buildingAreaScaledQuantity',
      // these legacy intensities will be actually shown
      // only if the org has data for them
      ...IntensityDenominatorKinds,
    ],
  },
  {
    measure: 'mwhConsumed',
    // per 1000 sq ft instead of per sq ft
    supportedDenominators: ['buildingAreaScaledQuantity'],
  },
];

export const SUBSTANCE_AND_MICROPLASTICS_INFLOW_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> =
  [
    {
      measure: 'kgMicroplasticsInflowQuantity',
      supportedDenominators: ['buildingAreaQuantity'],
    },
    {
      measure: 'kgSubstanceInflowQuantity',
      supportedDenominators: ['buildingAreaQuantity'],
    },
  ];

export const SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> =
  [
    {
      measure: 'kgMicroplasticsOutflowQuantity',
      supportedDenominators: ['buildingAreaQuantity'],
    },
    {
      measure: 'kgSubstanceOutflowQuantity',
      supportedDenominators: ['buildingAreaQuantity'],
    },
  ];

export const WATER_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'litersWaterUsedQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'litersWaterConsumedQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'litersWaterStoredQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'litersWaterRecycledQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'litersWaterDischargedQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
];

export const PRODUCT_CIRCULARITY_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'productQuantity',
    supportedDenominators: [],
  },
];

export const WASTE_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'kgWasteQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
];

export const BIODIVERSITY_DRILLDOWN_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'siteAreaQuantity',
    supportedDenominators: [],
  },
];

export const FACILITIES_WASTE_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'wasteQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
];
export const FACILITIES_WATER_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'waterUsageQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'waterRecyclingQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'waterStorageQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'waterConsumptionQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'waterDischargeQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
];

export const FACILITIES_MEASURES: Array<BiSupportedMeasure> = [
  {
    measure: 'buildingAreaQuantity',
    supportedDenominators: [],
  },
  {
    measure: 'electricityQuantity',
    supportedDenominators: ['buildingAreaQuantity'],
  },
  {
    measure: 'fuelQuantity',
    supportedDenominators: [],
  },
];

export const AGGREGATE_KIND_DISPLAY_VALUE: Record<AggregateMethod, string> = {
  sum: 'Sum',
  avg: 'Avg',
  monthlyAvg: 'Monthly avg',
};

export const ALL_SUPPORTED_MEASURES: Array<BiSupportedMeasure> =
  BASIC_DRILLDOWN_MEASURES.concat(
    SUBSTANCE_AND_MICROPLASTICS_INFLOW_DRILLDOWN_MEASURES,
    SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_DRILLDOWN_MEASURES,
    WATER_DRILLDOWN_MEASURES,
    PRODUCT_CIRCULARITY_MEASURES,
    WASTE_DRILLDOWN_MEASURES,
    BIODIVERSITY_DRILLDOWN_MEASURES,
    FACILITIES_WASTE_MEASURES,
    FACILITIES_WATER_MEASURES,
    FACILITIES_MEASURES
  );
